import { useEffect, useMemo, useRef, useState } from "react"
import { Button, Flex, Form, Modal, message } from "antd";
import PageHead from "@/components/PageHead";
import SafetyWarning from "@/components/SafetyWarning";
import { useTranslation } from "react-i18next";
import WalletAddressPanel from "./components/WalletAddressPanel";
import { SuiClient } from '@mysten/sui/client';
import SwapTokenSetting from "./components/SwapTokenSetting";
import { AggregatorClient, Env } from "@cetusprotocol/aggregator-sdk"
import { decodeSuiPrivateKey } from '@mysten/sui/cryptography';
import { Secp256k1Keypair } from '@mysten/sui/keypairs/secp256k1';
import { Secp256r1Keypair } from '@mysten/sui/keypairs/secp256r1';
import UploadModal from "@/components/UploadModal";
import { abi as IERC20ABI } from '@openzeppelin/contracts/build/contracts/ERC20.json';
import './index.less'
import { DataType, LogType } from "./interface";
import { Contract, formatEther, formatUnits, MaxUint256, Network, parseEther, parseUnits, Wallet } from "ethers";
import { getNativeTokenInfo } from "@/request/native";
import { useClient, useConfig } from "wagmi";
import { getProvider } from "@/config/net";
import erc20 from "@/abi/erc20.json";
import { Ed25519Keypair } from '@mysten/sui/keypairs/ed25519';
import AccountOverview from "./components/AccountOverview";
import { getSymbol } from "@/config/symbol";
import SwapParamsSetting from "./components/SwapParamsSetting";
import { NumType, Status } from "@/status/num";
import Logs from "./components/Logs";
import { NET_ID, DEFAULT_RPC, AUTO_SWAP_FEE_RATE } from "@/config";
import Loader from "@/components/Loader";
import { dividedBy, getRandomAmount, getRandomPercent, minus, multip, sum, calculateWithPercent } from "@/utils";
import BigNumber from "bignumber.js";
import { createTimeoutPromise, getChainsResource, processBatch } from "@/utils/methods";
import { SWAP_CONTRACT_ADDRESS, WETH_CONTRACT_ADDRESS } from "@/config/address";
import { erc20SwapErc20Pro, erc20SwapEthPro, ethSwapErc20Pro } from "../../utils/wrapperDexFunc";
import { getDefaultDex, getDexs, getRouterAddress, getFactoryAddress, getStableCoins, getSwapRouterAddress } from "@/config/dex";
import { getdexContract, getOkxSwap, getPrice, getQuote } from "@/request/getBestTrade";
import { concat, Hex, numberToHex, size } from "viem";
import { useFeeData } from "@/hooks/useFeeData";
import { useProvider } from "@/hooks/useProvider";
import { cdnUrl } from '@/utils/cdn';

import { isSuiCoinType, walletFromSuiPrivkey } from "@/utils/suiMethods";

import { Transaction } from "@mysten/sui/transactions";
import { FEE_ADDRESS } from "@/config/feeAddress";

const serviceFeeReceiver = FEE_ADDRESS.sui.batchSwap.serviceFeeReciver;

const suiClient = new SuiClient({
  url: DEFAULT_RPC,
})
const ag = new AggregatorClient({
  client: suiClient,
  env: Env.Mainnet,
})
const USDC_COINTYPE = "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC"

const dexsKey = Object.keys(getDexs());

const erc20Abi = erc20.output.abi;
const { imgPathPrefix } = getChainsResource();
const nativeCoin = getNativeTokenInfo();
const defaultDex = getDefaultDex();
const stableCoins = getStableCoins();
const stableCoinsAddress = stableCoins.map((item) => item.address);

const swapFeeRate = AUTO_SWAP_FEE_RATE

function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default function BatchSwap() {
  const { t, i18n } = useTranslation();
  const [isSelectOperate, setIsSelectOperate] = useState(true);
  const [tokenA, setTokenA] = useState<any>("0x2::sui::SUI");
  const [tokenB, setTokenB] = useState<any>("0x06864a6f921804860930db6ddbe2e16acdf8504495ea7481637a1c8b9a8fe54b::cetus::CETUS");
  const [selectedDex, setSelectedDex] = useState<string>(defaultDex);
  const [privateKeyList, setPrivateKeyList] = useState<string[]>([]);
  const [wallets, setWallets] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  // const [timeoutIds, setTimeoutIds] = useState<NodeJS.Timeout[]>([]); // 存储timeoutId的状态
  const [completedTasks, setCompletedTasks] = useState<number>(0); // 存储已完成任务的计数器
  const [failedTasks, setFailedTasks] = useState<number>(0); // 存储失败任务的计数器
  const [allTasksRun, setAllTasksRun] = useState<boolean>(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [poolId, setPoolId] = useState<any>({});
  const [isQueryLoading, setIsQueryLoading] = useState(0); // 查询流动性池标准 0: 未查询 1:查询中 2: 成功查到池子信息
  const [step, setStep] = useState(0); // 0 初始化 1 查询 池子 2 开始执行批量
  const [progress, setProgress] = useState<any>(0);
  const [tokenAInfo, setTokenAInfo] = useState<any>({
    coinType: "0x2::sui::SUI",
    decimals: 9,
    iconUrl: "",
    name: "Sui",
    symbol: "SUI",
    tokenType: "official",
    totalBalance: "0"
  });
  const [tokenBInfo, setTokenBInfo] = useState<any>({
    coinType: "0x06864a6f921804860930db6ddbe2e16acdf8504495ea7481637a1c8b9a8fe54b::cetus::CETUS",
    iconUrl: "https://uxcdefo3r2uemooidt2kk2stykakvwd2m6nasg5lhbfaxemm4i3a.arweave.net/pcQyFduOqEY5yBz0pWpTwoCq2HpnmgkbqzhKC5GM4jY",
    decimals: 9,
    name: "Cetus Token",
    symbol: "CETUS",
    tokenType: "official",
    totalBalance: "0"
  });
  const [otherTokenInfo, setOtherTokenInfo] = useState<any>({
    price: 0,
    symbol: ''
  }); // 选中的token中除bnb、稳定币以外token的ustd价格
  const [accountOverview, setAccountOverview] = useState<any>({})
  const [selectedAccountOverview, setSelectedAccountOverview] = useState<any>({})
  const [logs, setLogs] = useState<any>([])

  // const [isStopRequested, setIsStopRequested] = useState(false); // 是否停止交易
  const isStopRequested = useRef(false);
  const uploadModalRef = useRef<any>(null);
  const walletsRef = useRef(wallets);

  const [messageApi, contextHolder] = message.useMessage();
  const [v3FeeRate, setV3FeeRate] = useState<number>(2500);
  const [dex, setDex] = useState<string>("auto");
  const [isStopping, setIsStopping] = useState(false);

  const { customGasPrice } = useFeeData();
  const { provider } = useProvider();

  const USTD_ADDRESS = "";

  const BNB_ADDRESS = getSymbol();

  const nativeAndStableCoins = useMemo(() => ["0x2::sui::SUI", "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC", "0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT"], [])
  const isTokenANativeOrStable = useMemo(() => nativeAndStableCoins.includes(tokenAInfo.coinType), [tokenAInfo.coinType])
  const isTokenBNativeOrStable = useMemo(() => nativeAndStableCoins.includes(tokenBInfo.coinType), [tokenBInfo.coinType])
  const swapRouterAddressRef = useRef(getRouterAddress(NET_ID, selectedDex));
  // console.log("swapRouterAddressRef.current", swapRouterAddressRef.current);

  const { useForm, useWatch } = Form;
  const [form] = useForm();


  // const dex = useWatch('dex', form);
  const quantity = useWatch('quantity', form);
  // console.log("quantity", quantity)
  const minQuantity = useWatch('minQuantity', form);
  // console.log("minQuantity", minQuantity)
  const maxQuantity = useWatch('maxQuantity', form);
  // console.log("maxQuantity", maxQuantity)
  const minPercentage = useWatch('minPercentage', form);
  // console.log("minPercentage", minPercentage)
  const maxPercentage = useWatch('maxPercentage', form);
  // console.log("maxPercentage", maxPercentage)
  const decimalPlaces = useWatch('decimalPlaces', form);
  // console.log("decimalPlaces", decimalPlaces)
  const amountType = useWatch('amountType', form);
  // console.log("amountType", amountType)
  const stopType = useWatch('stopType', form);
  // console.log("stopType", stopType)
  const stopInput = useWatch('stopInput', form);
  // console.log("stopInput", stopInput)

  const onFormValuesChange = (changedValues: any, allValues: any) => {
    console.log(changedValues, allValues)
  };

  const openUploadModal = () => {
    function cb() {
      if (uploadModalRef.current) {
        uploadModalRef.current?.init();
      }
    }
    cb();
  };

  function onSubmitKeyPair(keypairs: string) {
    setListLoading(true)
    const tempList = keypairs.split('\n');
    const keypairList = tempList.filter((item: string) => item !== '');
    setPrivateKeyList([...keypairList]);
  }

  function onDeleteIem({ key }: DataType) {
    privateKeyList.splice(key as number, 1);
    const updateSelectedRowKeys = selectedRowKeys.filter((item: any) => item !== key);
    const tmp = walletsRef.current.filter((wallet: DataType) => wallet.key !== key);
    const updatedList = tmp.map((item: DataType, index: number) => ({
      ...item,
    }));
    walletsRef.current = updatedList;
    setWallets([...updatedList]);
    setSelectedRowKeys(updateSelectedRowKeys);
  }

  // 定义删除钱包的方法
  const onDelWallet = (newWallets: any) => {
    setWallets(newWallets);
  };

  // 获取选中除bnb、稳定币以外token的ustd价格
  const getOtherTokenInfo = async () => {
    const isTokenANativeOrStable = nativeAndStableCoins.includes(tokenAInfo.coinType);

    const isTokenBNativeOrStable = nativeAndStableCoins.includes(tokenBInfo.coinType);
    try {
      if (isTokenANativeOrStable && isTokenBNativeOrStable) {
        return {
          price: 0,
          symbol: tokenB
        }
      } else {
        const routers: any = await ag.findRouters({
          from: isTokenANativeOrStable ? tokenB : tokenA,
          target: USDC_COINTYPE,
          amount: parseUnits("1", isTokenANativeOrStable ? tokenBInfo.decimals : tokenAInfo.decimals),
          byAmountIn: true
        })
        const outAmount = routers?.amountOut?.toString() || BigInt(0);

        return {
          price: formatUnits(outAmount, 6),
          symbol: isTokenANativeOrStable ? tokenBInfo.symbol : tokenAInfo.symbol
        }
      }
    } catch (error) {
      console.error("getOtherTokenInfo error:", error);
      return {
        price: 0,
        symbol: "",
      };
    }
  };

  const queryOtherTokenInfo = async () => {
    setOtherTokenInfo({
      price: 0,
      symbol: ''
    })
    const otherTokenInfo = await getOtherTokenInfo();
    setOtherTokenInfo(otherTokenInfo);
  }
  // console.log("otherTokenInfo", otherTokenInfo)

  const addLog = (newLog: LogType) => {
    const uniqueRandomValue = Date.now() + Math.random();
    newLog.key = sum(newLog.key, uniqueRandomValue);
    setLogs((prevLogs: LogType[]) => {
      const maxSequence = prevLogs.length > 0 ? Math.max(...prevLogs.map((log: LogType) => log.sequence)) : 1;
      newLog.sequence = maxSequence
      return [newLog, ...prevLogs]
    });
  };

  function handleHash(TxStatus: string, hash: string, tokenAAmount: bigint, wallet: DataType, isLoopExecution = false, currentIteration: number, totalIterations: number) {
    const { key, walletAddress } = wallet
    if (TxStatus == "success") {
      if (isLoopExecution && currentIteration <= totalIterations) {
        // 获取当前钱包的最新状态
        const currentWallet = walletsRef.current.find(w => w.key === wallet.key);
        // 创建更新后的钱包对象
        let updatedWallet = {
          ...currentWallet,
          successHashs: [...(currentWallet?.successHashs || []), hash],
        };

        if (currentIteration === totalIterations) {
          updatedWallet = {
            ...updatedWallet,
            status: Status.Success,
            tx: hash,
            msg: '成功',
          }
        }

        // 更新钱包列表
        setWallets(prevWallets =>
          prevWallets.map(w => w.key === wallet.key ? updatedWallet : w)
        );

        // 同时更新 walletsRef
        // walletsRef.current = walletsRef.current.map(w =>
        //   w.key === wallet.key ? updatedWallet : w
        // );
      } else {
        updateWalletInfo(wallet, Status.Success, hash, '成功')
      }

      addLog({
        key,
        address: walletAddress,
        time: Date.now(),
        mintInAmount: formatUnits(tokenAAmount.toString(), tokenAInfo.decimals || 18),
        status: Status.Success,
        tx: hash,
        msg: '成功',
        tokenASymbol: tokenAInfo.symbol,
        tokenBSymbol: tokenBInfo.symbol,
        tokenALogo: tokenAInfo.logo || tokenAInfo.logoURI || cdnUrl("/img/bsc/default-logo.svg"),
        tokenBLogo: tokenBInfo.logo || tokenBInfo.logoURI || cdnUrl("/img/bsc/default-logo.svg"),
      })
    } else {
      if (isLoopExecution) {
        // 获取当前钱包的最新状态
        const currentWallet = walletsRef.current.find(w => w.key === wallet.key);
        // 创建更新后的钱包对象，增加失败次数
        let updatedWallet = {
          ...currentWallet,
          failedCount: (currentWallet?.failedCount || 0) + 1,
        };

        if (currentIteration === totalIterations) {
          updatedWallet = {
            ...updatedWallet,
            status: Status.Fail,
            tx: hash,
            msg: '失败',
          }
        }

        // 更新钱包列表
        setWallets(prevWallets =>
          prevWallets.map(w => w.key === wallet.key ? updatedWallet : w)
        );

        // 同时更新 walletsRef
        // walletsRef.current = walletsRef.current.map(w =>
        //   w.key === wallet.key ? updatedWallet : w
        // );
      } else {
        updateWalletInfo(wallet, Status.Fail, hash, '失败')
      }

      addLog({
        key,
        address: walletAddress,
        time: Date.now(),
        mintInAmount: formatUnits(tokenAAmount.toString(), tokenAInfo.decimals || 18),
        status: Status.Fail,
        tx: hash,
        msg: '失败',
        tokenASymbol: tokenAInfo.symbol,
        tokenBSymbol: tokenBInfo.symbol,
        tokenALogo: tokenAInfo.logo || tokenAInfo.logoURI || cdnUrl("/img/bsc/default-logo.svg"),
        tokenBLogo: tokenBInfo.logo || tokenBInfo.logoURI || cdnUrl("/img/bsc/default-logo.svg"),
      })
    }
  }
  function handleNoEnoughtBalance(wallet: DataType, tokenAmount: number, msg: string, isLoopExecution = false, currentIteration: number, totalIterations: number) {
    if (isLoopExecution && currentIteration <= totalIterations) {
      // 获取当前钱包的最新状态
      const currentWallet = walletsRef.current.find(w => w.key === wallet.key);
      // 创建更新后的钱包对象，增加失败次数
      let updatedWallet = {
        ...currentWallet,
        failedCount: (currentWallet?.failedCount || 0) + 1,
      };

      if (currentIteration === totalIterations) {
        updatedWallet = {
          ...updatedWallet,
          status: Status.Fail,
          tx: '',
          msg
        }
      }

      // 更新钱包列表
      setWallets(prevWallets =>
        prevWallets.map(w => w.key === wallet.key ? updatedWallet : w)
      );
    } else {
      updateWalletInfo(wallet, Status.Fail, '', msg);
    }

    addLog({
      key: wallet.key,
      address: wallet.walletAddress,
      time: Date.now(),
      mintInAmount: tokenAmount,
      status: 3,
      tx: '',
      msg,
      tokenASymbol: tokenAInfo.symbol,
      tokenBSymbol: tokenBInfo.symbol,
      tokenALogo: tokenAInfo.logo || tokenAInfo.logoURI || cdnUrl("/img/bsc/default-logo.svg"),
      tokenBLogo: tokenBInfo.logo || tokenBInfo.logoURI || cdnUrl("/img/bsc/default-logo.svg"),
    });
  }


  async function getAllCoinsOfType(
    suiClient: SuiClient,
    owner: string,
    coinType: string,
    pageLimit = 50
  ): Promise<any> {
    const all: any = [];
    let cursor: string | null | undefined = null;

    while (true) {
      const page = await suiClient.getCoins({
        owner,
        coinType,
        cursor,
        limit: pageLimit,
      });

      for (const c of page.data) {
        all.push({ coinObjectId: c.coinObjectId, balance: c.balance });
      }

      if (!page.hasNextPage) break;
      cursor = page.nextCursor;
    }

    return all;
  }
  // 把 coinIds 全部 merge 到 coinIds[0]（可在同一个 txb 中多次 mergeCoins 分批执行）
  function mergeAllCoinsIntoOneInTxb(
    txb: Transaction,
    coinIds: string[],
    chunkSize = 200
  ) {
    if (coinIds.length <= 1) {
      return { baseCoinId: coinIds[0] ?? null, merged: false };
    }

    const baseCoinId = coinIds[0];
    const base = txb.object(baseCoinId);

    // 分批把后面的 coins merge 进去
    for (let i = 1; i < coinIds.length; i += chunkSize) {
      const batch = coinIds.slice(i, i + chunkSize);
      txb.mergeCoins(
        base,
        batch.map((id) => txb.object(id))
      );
    }

    return { baseCoinId, merged: true };
  }
  async function handleAutoSwap(
    wallet: any,
    tokenAAmount: bigint,
    slip: number,
    isLoopExecution = false,
    currentIteration: number,
    totalIterations: number,
  ) {
    try {
      // const swapReceipt = await autoSwap(wallet, tokenA, slip, tokenB, tokenAAmount, customGasPrice, swapFee)
      const tx = new Transaction();
      let mergedCoin;
      if (isSuiCoinType(tokenAInfo.coinType)) {
        console.log("我是sui", tokenAAmount)

        mergedCoin = tx.gas;
      } else {
        const coins = await getAllCoinsOfType(suiClient, wallet.walletAddress, tokenAInfo.coinType);
        // 3) 按余额从大到小排序，选余额最大的当 base
        coins.sort((a: any, b: any) => (BigInt(b.balance) > BigInt(a.balance) ? 1 : -1));
        const coinIds = coins.map((c: any) => c.coinObjectId);
        // 4) 在同一个 txb 里把所有 USDC 合并成一枚
        const { baseCoinId } = mergeAllCoinsIntoOneInTxb(tx, coinIds, 200);
        if (!baseCoinId) throw new Error("No  coins");
        // base USDC coin（合并后的承载 coin）
        mergedCoin = tx.object(baseCoinId);
      }
      const [needCoin] = tx.splitCoins(mergedCoin, [tx.pure.u64(tokenAAmount)]);
      const routers: any = await ag.findRouters({
        from: tokenA,
        target: tokenB,
        amount: tokenAAmount,
        byAmountIn: true
      })
      console.log("执行的routers", routers)
      if (!routers.quoteID) {
        throw new Error("insufficient liquidity")
      }
      console.log("执行的slip", slip)
      const targetCoin = await ag.routerSwap({
        router: routers,
        txb: tx,
        inputCoin: needCoin, // the whole coin will be used in the swap.
        slippage: slip / 100,
      })
      console.log("执行的targetCoin", targetCoin)
      //手续费
      if (isTokenANativeOrStable) {
        const [feeCoin] = tx.splitCoins(mergedCoin, [tx.pure.u64(BigInt(routers?.amountIn.toString()) * BigInt(8) / BigInt(1000))])
        tx.transferObjects([feeCoin], tx.pure.address(serviceFeeReceiver))
      } else {
        const [feeCoin] = tx.splitCoins(targetCoin, [tx.pure.u64(BigInt(routers?.amountOut.toString()) * BigInt(8) / BigInt(1000))])
        tx.transferObjects([feeCoin], tx.pure.address(serviceFeeReceiver))
      }
      tx.transferObjects([targetCoin], tx.pure.address(wallet.walletInstance.address))
      const result = await suiClient.signAndExecuteTransaction({
        signer: wallet.walletInstance.keypair,
        transaction: tx
      })
      console.log('tx', tx)
      const ultimateRes = await suiClient.waitForTransaction({
        digest: result.digest,
        options: {
          showEffects: true,
        },
        timeout: 60_000,
        pollInterval: 2_000,
      });
      const status = ultimateRes.effects?.status.status;
      const error = ultimateRes.effects?.status.error;
      // console.log('ultimateResXXXX', ultimateRes);
      if (status !== 'success') {
        throw new Error(error);
      }
      handleHash(status, result.digest, tokenAAmount, wallet, isLoopExecution, currentIteration, totalIterations)
      setCompletedTasks((prevCompletedTasks) => prevCompletedTasks + 1);
      return status;
    } catch (error) {
      console.log("handleAutoSwapError", error)
      setFailedTasks((prev) => prev + 1)
      if (error.receipt) {
        const { status, hash: errorHash } = error.receipt
        handleHash(status, errorHash, tokenAAmount, wallet, isLoopExecution, currentIteration, totalIterations)
      }
      if (error == "Error: insufficient liquidity") {
        const Amount = Number(formatUnits(tokenAAmount, tokenAInfo.decimals))
        handleNoEnoughtBalance(wallet, Amount, t("流动性不足"), isLoopExecution, currentIteration, totalIterations)
      }
      else {
        const Amount = Number(formatUnits(tokenAAmount, tokenAInfo.decimals))
        handleNoEnoughtBalance(wallet, Amount, t("tokenBatchCollection.noEnoughtGas"), isLoopExecution, currentIteration, totalIterations)
      }
      return "error"
    }
  }

  function updateWalletInfo(wallet: DataType, status: Status = Status.NoStart, hash = '', msg = '') {
    // 使用 ref 直接操作钱包列表
    const updatedWallets = walletsRef.current.map((item: DataType) => {
      if (item.key === wallet.key) {
        return {
          ...item,  // 包含更新后的 successHashs
          status,
          tx: hash,
          msg
        }; // 更新钱包状态
      }
      return item;
    });

    // 更新 ref 中的钱包列表
    walletsRef.current = updatedWallets;

    // 如果需要触发 UI 更新，可以同步更新 React 状态
    setWallets([...updatedWallets]);
  }

  async function calculateTokenAmount(wallet: DataType): Promise<bigint> {
    // Gas 费用转换为 wei
    const GAS_FEE = 10000000n; // 测试网链上服务费（主网需要调整）
    // const SWAP_FEE = swapFee; // swap费用
    // const TOTAL_FEE = GAS_FEE + SWAP_FEE;

    let countBalance: bigint | string = 0n;
    try {
      let balanceRes = await suiClient.getBalance({
        owner: wallet.walletAddress,
        coinType: tokenA
      })
      countBalance = balanceRes.totalBalance;
    } catch (error) {
      console.error('获取最新余额失败:', error);
    }

    let tokenAmount = 0n;

    switch (amountType) {
      case NumType.All:
        tokenAmount = isSuiCoinType(tokenA)
          ? BigInt(countBalance.toString()) - GAS_FEE
          : BigInt(countBalance.toString());
        break;
      case NumType.Fixed:
        if (!quantity) return 0n;
        tokenAmount = parseUnits(quantity.toString(), tokenAInfo.decimals || 9);
        break;
      case NumType.RandomAmount:
        if (minQuantity && maxQuantity && decimalPlaces) {
          if (Number(minQuantity) > Number(maxQuantity) ||
            isNaN(Number(minQuantity)) ||
            isNaN(Number(maxQuantity))) return 0n;

          const randomAmount = getRandomAmount(
            Number(minQuantity),
            Number(maxQuantity),
            Number(decimalPlaces)
          );
          tokenAmount = parseUnits(randomAmount.toString(), tokenAInfo.decimals || 9);
        }
        break;

      case NumType.RandomPercent:
        if (minPercentage && maxPercentage) {
          if (Number(minPercentage) > Number(maxPercentage) ||
            isNaN(Number(minPercentage)) ||
            isNaN(Number(maxPercentage))) return 0n;

          const randomPercent = getRandomPercent(
            Number(minPercentage),
            Number(maxPercentage)
          );
          const randomAmount = calculateWithPercent(BigInt(countBalance), randomPercent);
          tokenAmount = randomAmount
        }
        break;

      case NumType.ReservedAmount: {
        if (!quantity) return 0n;
        const reservedAmountWei = parseUnits(quantity.toString(), tokenAInfo.decimals || 18);
        if (reservedAmountWei > BigInt(countBalance)) return 0n;

        tokenAmount = isSuiCoinType(tokenA)
          ? BigInt(countBalance) - reservedAmountWei - GAS_FEE
          : BigInt(countBalance) - reservedAmountWei
        break;
      }
    }
    return tokenAmount;
  }
  console.log("isStopRequested", isStopRequested)
  async function handleBatchSwap(selectedWallets: DataType[], values: any) {
    // 重置停止状态
    isStopRequested.current = false;
    const {
      slip,
      slipInput,
      fixedTaskTime,
      stopType,
      stopInput,
      openRandomTaskTime,
      randomTaskTimeStart,
      randomTaskTimeEnd,
      threads
    } = values;
    // 创建执行单个钱包交易的异步函数
    async function executeWalletSwap(
      wallet: any,
      isLoopExecution: boolean,
      currentIteration: number,
      totalIterations: number,
      precomputed?: { tokenAmountWei?: bigint; minAmountOut?: string }
    ) {
      // console.log("isStopRequested.current", isStopRequested.current)
      if (isStopRequested.current) {
        // openSuccessModal();
        setIsStopping(false);
        return
      }
      let isContinue = "";
      // 只在第一次迭代时设置Loading状态
      if (currentIteration === 0) {
        updateWalletInfo(wallet, Status.Loading, '', '')
      }

      const tokenAmountWei = precomputed?.tokenAmountWei ?? await calculateTokenAmount(wallet);
      const tokenAmount = Number(formatUnits(tokenAmountWei.toString(), tokenAInfo.decimals || 9));

      // 实时获取钱包最新的 tokenA 余额
      let currentTokenBalance: bigint;
      try {
        let tokenABalanceObj = await suiClient.getBalance({ owner: wallet.walletAddress, coinType: tokenAInfo.coinType });
        currentTokenBalance = BigInt(tokenABalanceObj.totalBalance);
      } catch (error) {
        console.error('获取最新余额失败:', error);
        handleNoEnoughtBalance(
          wallet,
          tokenAmount,
          'NetWork Error',
          isLoopExecution,
          currentIteration,
          totalIterations - 1
        );
        setFailedTasks((prev) => prev + 1);
        return false;
      }

      // 检查最新余额是否足够支付本次交易
      const tokenAmountBN = new BigNumber(tokenAmountWei.toString());
      const currentBalanceBN = new BigNumber(currentTokenBalance.toString());
      const hasSufficientBalance = tokenAmountBN.gt(0) && tokenAmountBN.lte(currentBalanceBN);

      if (!hasSufficientBalance) {

        handleNoEnoughtBalance(
          wallet,
          tokenAmount,
          t("manyToMany.insufficientBalance", { symbol: tokenAInfo.symbol }),
          isLoopExecution,
          currentIteration,
          totalIterations - 1
        );
        setFailedTasks((prev) => prev + 1);
        return false;
      }

      // 只在需要检查价格条件时获取价格
      if (stopType === 1 || stopType === 2) {
        // 获取当前代币价格
        const { price: currentOtherTokenPrice } = await getOtherTokenInfo();
        // console.log("currentOtherTokenPrice", currentOtherTokenPrice);

        // 根据stopType和价格条件执行交易
        if (stopType === 1 && Number(currentOtherTokenPrice) >= Number(stopInput)) {
          // console.log("stopInput", stopInput)
          // updateWalletInfo(wallet, Status.NoStart, '', '');
          updateWalletInfo(wallet, 4, '', '');
          return;
        } else {
          isContinue = "continue"
        }
        // console.log("stopInput 111", stopInput)
        if (stopType === 2 && Number(currentOtherTokenPrice) <= Number(stopInput)) {
          // updateWalletInfo(wallet, Status.NoStart, '', '');
          updateWalletInfo(wallet, 4, '', '');
          return;
        } else {
          isContinue = "continue"
        }

      }
      // console.log("退出", dex)
      const slipTmp = slip === 51 ? 50 : (Number(slip != -1 ? slip : slipInput));

      if (dex === "auto") {
        const res = await handleAutoSwap(wallet, tokenAmountWei, slipTmp, isLoopExecution, currentIteration, totalIterations - 1)
        // console.log("ressss1", res);
        if (res == "error") {
          return
        } else {
          return isContinue;
        }

      }

      return;
    }

    // 分组执行任务的函数
    async function executeWalletGroup(wallets: DataType[], values: any) {
      const { stopType, stopInput } = values;
      const executionTimes = stopType === 0 ? Number(stopInput) : 1; // 每个钱包要执行的次数
      const isLoopExecution = stopType === 0 && Number(stopInput) > 1;

      for (let i = 0; i < executionTimes; i++) {
        // console.log("isStopRequested", isStopRequested.current);
        // 检查是否请求停止
        if (isStopRequested.current) {
          // console.log('交易已停止');
          return;
        }

        const tokenAmounts = await Promise.all(
          wallets.map(wallet => calculateTokenAmount(wallet))
        );
        // console.log("计算 tokenAmounts", tokenAmounts)

        let precomputedMinAmounts: (string | undefined)[] = new Array(wallets.length).fill(undefined);
        const slipValue = slip === 51 ? 50 : Number(slip != -1 ? slip : slipInput);
        // console.log("计算 precomputedMinAmounts", precomputedMinAmounts)
        // console.log("计算 slipValue", slipValue)

        //通过滑点计算最小接收金额
        const rouetrs: any = await ag.findRouters({
          from: tokenAInfo.coinType,
          target: tokenBInfo.coinType,
          amount: tokenAmounts[0].toString(),
          byAmountIn: true, // `true` means fix input amount, `false` means fix output amount
        })
        // console.log("计算 rouetrs")

        precomputedMinAmounts = [String(BigInt(rouetrs?.amountOut.toString()) * BigInt(100 - slipValue) / BigInt(100))];
        // console.log("计算 precomputedMinAmounts", precomputedMinAmounts)
        // console.log("tokenAmounts", tokenAmounts);
        // console.log("precomputedMinAmounts", precomputedMinAmounts);

        // 传入当前迭代次数和总迭代次数
        await Promise.all(wallets.map(async (wallet, index) => {
          const execute = async () => {
            let res = await executeWalletSwap(wallet, isLoopExecution, i, executionTimes, {
              tokenAmountWei: tokenAmounts[index],
              minAmountOut: precomputedMinAmounts[index],
            });
            // console.log("res ssss", res);
            while (res == "continue") {
              const tokenAmount = await calculateTokenAmount(wallet);
              res = await executeWalletSwap(wallet, isLoopExecution, i, executionTimes, {
                tokenAmountWei: tokenAmount,
                minAmountOut: "0",
              });
            }
          }
          await execute();
          return
        }));

        let delay = fixedTaskTime;
        if (openRandomTaskTime) {
          delay = randomTaskTimeStart + Math.random() * (randomTaskTimeEnd - randomTaskTimeStart);
        }

        await new Promise(resolve => setTimeout(resolve, delay * 1000));
      }
    }

    // 将钱包列表分组
    const walletGroups: any[][] = [];
    for (let i = 0; i < selectedWallets.length; i += threads) {
      walletGroups.push(selectedWallets.slice(i, i + threads));
    }
    // console.log("walletGroups", walletGroups)
    // // 顺序执行每组任务
    for (const group of walletGroups) {
      // 检查是否请求停止
      if (isStopRequested.current) {
        // console.log('后续任务已取消', isStopRequested.current);
        break;
      }
      await executeWalletGroup(group, values);
    }
  }
  console.log("stopType", stopType)
  async function swap(values: any) {
    const { price: currentOtherTokenPrice } = await getOtherTokenInfo();
    if (stopType == 1 && currentOtherTokenPrice >= stopInput) {
      // 当前价格高于触发价格，无法执行
      message.error("batchSwap.priceAboveTriggerCannotExecute")
      return
    }
    if (stopType == 2 && currentOtherTokenPrice <= stopInput) {
      // message.error("当前价格低于触发价格，无法执行")
      message.error("batchSwap.priceBelowTriggerCannotExecute")
      return
    }
    handleClearLogs();
    // if(nativeAndStableCoins.includes(tokenAInfo.coinType)&&nativeAndStableCoins.includes(tokenBInfo.coinType) ){
    //   message.error("不能两个代币都是稳定币")
    //   return 
    // }
    setLoading(true);
    setCompletedTasks(0);
    setFailedTasks(0);
    setAllTasksRun(false);
    setStep(1);

    // console.log("开始swap")
    // 超时时间
    // const deadline = Math.floor(Date.now() / 1000) + 60 * 20;
    let selectedWallets: any[] = walletsRef.current.filter((wallet: any) => selectedRowKeys.includes(wallet.key));
    // console.log("开始swap selectedWallets", selectedWallets)
    // 当 stopType 为 0 且 stopInput > 1 时重置选中钱包的状态
    if (values.stopType === 0 && values.stopInput > 1) {
      selectedWallets = selectedWallets.map(wallet => ({
        ...wallet,
        successHashs: [],
        failedCount: 0
      }));

      // 只更新选中的钱包
      const walletMap = new Map(walletsRef.current.map(w => [w.key, w]));
      selectedWallets.forEach(wallet => {
        walletMap.set(wallet.key, wallet);
      });

      walletsRef.current = Array.from(walletMap.values());
      setWallets(walletsRef.current);
    }

    // console.log("selectedWallets", selectedWallets)

    await handleBatchSwap(selectedWallets, values);
    // 所有任务完成后的处理
    setLoading(false);
    setStep(0);
    if (isStopRequested.current) {
      openSuccessModal();
      setIsStopping(false);
    }
    await queryWalletsCurrentBalance();
    openSuccessModal();
    setIsStopping(false);
  }

  function onSubmit() {
    if (selectedRowKeys.length === 0) return;
    if (!poolId && dex !== "auto") {
      messageApi.warning(t("batchSwap.noPool"));
      return;
    };
    form.validateFields()
      .then(values => {
        // 表单校验通过，values为表单的值
        // console.log('Success:', values);
        // 在这里处理表单提交等逻辑
        // debugger
        swap(values)
      })
      .catch(errorInfo => {
        // 表单校验失败
        console.log('Failed:', errorInfo);
        // 在这里处理校验失败的逻辑，例如显示错误信息
      });
  }

  function handleClearLogs() {
    setLogs([]);
  }

  function onSwitch() {
    setIsSelectOperate(false)
    const newTokenA = tokenB;
    const newTokenB = tokenA;
    // const newTokenAInfo = tokenAInfo;
    // const newTokenBInfo = tokenBInfo;

    setTokenA(newTokenA);
    setTokenB(newTokenB);
    // setTokenAInfo(newTokenBInfo);
    // setTokenBInfo(newTokenAInfo);
  }

  async function queryRouter() {
    setIsQueryLoading(1)
    // console.log("查询")
    try {
      const router = await ag.findRouters({
        from: tokenA,
        target: tokenB,
        amount: "100000",
        byAmountIn: true, // `true` means fix input amount, `false` means fix output amount
      })

      if (router?.quoteID) {
        setIsQueryLoading(2)
        // 流动性查询成功
        message.success(t("batchSwap.liquidityQuerySuccess"))
      } else {
        // 流动性查询失败
        message.error(t("batchSwap.liquidityQueryFailed"))
      }
      // console.log("router", router)
    } catch (error) {
      setIsQueryLoading(0)
    }

  }

  async function queryWalletsCurrentBalance() {


    const currentWallets = walletsRef.current; // 使用 walletsRef.current
    try {
      const updatedWallets = await Promise.all(
        currentWallets.map(async (wallet: any) => {
          const address = wallet.walletAddress;
          const item: any = { ...wallet };

          // 更新sui余额
          const balanceWei = (await suiClient.getBalance({ owner: address })).totalBalance;
          item.balance = formatUnits(balanceWei, 9);
          item.balanceWei = balanceWei;
          // 更新tokenA余额
          const tokenABalanceWei = (await suiClient.getBalance({ owner: address, coinType: tokenA })).totalBalance;
          item.tokenABalance = formatUnits(tokenABalanceWei, tokenAInfo.decimals); // stableCoins[0] 是usdt 或 usdc
          item.tokenABalanceWei = tokenABalanceWei;
          // 更新tokenB余额
          const tokenBBalanceWei = (await suiClient.getBalance({ owner: address, coinType: tokenB })).totalBalance;
          item.tokenBBalance = formatUnits(tokenBBalanceWei, tokenBInfo.decimals); // stableCoins[0] 是usdt 或 usdc
          item.tokenBBalanceWei = tokenBBalanceWei;

          return item;
        })

      );
      setWallets(updatedWallets);
      return true;
    } catch (error) {
      console.log('更新代币余额error', error);
      return false;
    }
  }

  async function handleprivateKey(chunkSize: number = 500) {
    try {
      setSelectedRowKeys([]);
      setListLoading(true);
      setProgress(0);
      const walletList = privateKeyList.map(pk => walletFromSuiPrivkey(pk));
      // console.log("walletList", walletList)
      const addresses = walletList.map((wallet: any) => wallet.address)

      // 2. 定义存放结果的数组
      const items = new Array(privateKeyList.length);

      // 3. 分批处理
      //    - 每次取 chunkSize 个地址
      for (let i = 0; i < addresses.length; i += chunkSize) {
        // 3.1 截取一批地址、对应的钱包
        const chunkAddresses = addresses.slice(i, i + chunkSize);
        const chunkWallets = walletList.slice(i, i + chunkSize);

        // 3.2 并发获取本批次所有地址的 sui 币 & USDC 余额
        const [nativeBalanceList, tokenABalanceList, tokenBBalanceList] = await Promise.all([
          Promise.all(chunkAddresses.map(addr => suiClient.getBalance({
            owner: addr
          }))),
          Promise.all(chunkAddresses.map(addr => suiClient.getBalance({
            owner: addr,
            coinType: tokenA
          }))),
          Promise.all(chunkAddresses.map(addr => suiClient.getBalance({
            owner: addr,
            coinType: tokenB
          }))),
        ]);
        // console.log("nativeBalanceList", nativeBalanceList)
        // console.log("tokenABalanceList", tokenABalanceList)
        // console.log("tokenBBalanceList", tokenBBalanceList)
        // 3.3 组装本批次的结果到 items
        chunkAddresses.forEach((addr, indexInChunk) => {
          const globalIndex = i + indexInChunk; // 对应在原始列表中的索引
          const balanceWei = nativeBalanceList[indexInChunk].totalBalance;
          const tokenABalanceWei = tokenABalanceList[indexInChunk].totalBalance;
          const tokenBBalanceWei = tokenBBalanceList[indexInChunk].totalBalance;

          items[globalIndex] = {
            key: globalIndex,
            privateKey: privateKeyList[globalIndex],
            walletAddress: addr,
            balance: formatUnits(balanceWei, 9),
            balanceWei: balanceWei,
            tokenABalance: formatUnits(tokenABalanceWei, tokenAInfo.decimals), // stableCoins[0] 是usdt 或 usdc
            tokenABalanceWei: tokenABalanceWei,
            tokenBBalance: formatUnits(tokenBBalanceWei, tokenBInfo.decimals || 18),
            tokenBBalanceWei: tokenBBalanceWei,
            walletInstance: chunkWallets[indexInChunk],
            approvedToken: [],
            successHashs: [],
            failedCount: 0,
            status: 0,
            tx: '',
            msg: '',
          };
        });

        // 3.4 更新进度
        //     已处理的数量 = i + 当前批次的数量
        const processedCount = i + chunkAddresses.length;
        setProgress((processedCount / addresses.length) * 100);
      }

      // 4. 全部批次处理完毕，更新状态
      setWallets(items);
      setListLoading(false);
    } catch (error) {
      console.error('查询代币余额失败:', error);
      setListLoading(false);
      // 如果需要，可以提示错误信息
      // message.error('导入失败，请重试');
    }
  }


  function postAccountOverview(data: any) {
    const { accountOverview, selectedAccountOverview } = data
    setAccountOverview(accountOverview)
    setSelectedAccountOverview(selectedAccountOverview)
  }

  function openSuccessModal() {
    setIsSuccessModal(true)
  }

  function hideSuccessModal() {
    setIsSuccessModal(false)
  }

  function stopSwap() {
    // console.log('stopSwap');
    isStopRequested.current = true;
    setIsStopping(true);
    // setStep(0);
    // setLoading(false);
  }

  useEffect(() => {
    // 每次钱包状态变更时更新 walletsRef
    walletsRef.current = wallets;
  }, [wallets]);

  // 检查是否弹出弹窗
  useEffect(() => {
    const totalTasks = stopType === 0 ?
      selectedRowKeys.length * Number(stopInput) :
      selectedRowKeys.length;

    if (completedTasks > 0 && completedTasks + failedTasks === totalTasks && !loading) {
      openSuccessModal();
    }
  }, [completedTasks, failedTasks]);


  // console.log("privateKeyList", privateKeyList)
  useEffect(() => {
    if (privateKeyList.length > 0) {
      // console.log("privateKeyList", privateKeyList)
      handleprivateKey()
      // 在这里处理 token 改变后的逻辑

    }
  }, [privateKeyList]); // 监听 selectedToken 变化

  useEffect(() => {
    if (tokenA && tokenB && wallets.length > 0) {
      queryWalletsCurrentBalance()
    }
  }, [tokenAInfo, tokenBInfo]);


  useEffect(() => {
    if (tokenAInfo.coinType && tokenBInfo.coinType) {
      queryOtherTokenInfo()
    }
  }, [tokenAInfo, tokenBInfo]);

  useEffect(() => {
    if (dex) {
      swapRouterAddressRef.current = getSwapRouterAddress(NET_ID, dex);
      // console.log("swapRouterAddressRef.current", swapRouterAddressRef.current);
    }
  }, [dex]);
  // console.log("s1");
  useEffect(() => {
    if (provider && wallets.length > 0) {
      // 使用新的provider重新实例化所有wallet
      const updatedWallets = wallets.map((wallet: DataType) => ({
        ...wallet,
        walletInstance: new Wallet(wallet.privateKey, provider)
      }));
      setWallets(updatedWallets);
    }
  }, [provider])



  return (
    <>
      {contextHolder}
      <Form
        layout="vertical"
        name="batchSwap"
        form={form}
        onValuesChange={onFormValuesChange}
        // onFinish={onFinish}
        initialValues={{
          // dex: getDefaultDex(),
          dex: "auto",
          amountType: NumType.All,
          decimalPlaces: 4, // 小数位数
          randomTaskTimeStart: 1,
          randomTaskTimeEnd: 5,
          slip: 51,
          slipInput: 3,
          stopType: 0,
          stopInput: 1,
          stopPrice: 0,
          fixedTaskTime: 1,
          threads: 1,
          // v3FeeRate: 2500,
        }}
      >
        <div className="batch-swap">
          <PageHead title={t('batchSwap.nav')} desc={t('batchSwap.desc')}>
            <SafetyWarning />
          </PageHead>
          <div className="batch-swap-box">
            <div className="swap-box-row">
              <section className="swap-sider">
                <AccountOverview
                  otherTokenInfo={
                    [BNB_ADDRESS, USTD_ADDRESS].includes(tokenA) ? tokenBInfo : tokenAInfo
                  }
                  accountOverview={accountOverview}
                  selectedAccountOverview={selectedAccountOverview}
                  tokenA={tokenA}
                  tokenAInfo={tokenAInfo}
                  tokenBInfo={tokenBInfo}
                />
                <SwapTokenSetting
                  isTokenANativeOrStable={isTokenANativeOrStable}
                  isTokenBNativeOrStable={isTokenBNativeOrStable}
                  form={form}
                  tokenA={tokenA}
                  setTokenA={setTokenA}
                  setTokenAInfo={setTokenAInfo}
                  setTokenBInfo={setTokenBInfo}
                  tokenB={tokenB}
                  setTokenB={setTokenB}
                  isSelectOperate={isSelectOperate}
                  setIsSelectOperate={setIsSelectOperate}
                  onSwitch={onSwitch}
                  isQueryLoading={isQueryLoading}
                  queryRouter={queryRouter}
                // dex={dex}
                />
              </section>
              <div className="swap-main">
                <WalletAddressPanel
                  otherTokenInfo={
                    [BNB_ADDRESS, USTD_ADDRESS].includes(tokenA) ? tokenBInfo : tokenAInfo
                  } // 除bnb、USDT以外的tokenInfo
                  // selectedTokenInfo={tokenAInfo}
                  wallets={wallets}
                  executionTimes={stopInput}
                  isLoopExecution={stopType === 0 && stopInput > 1}
                  queryWalletsCurrentBalance={queryWalletsCurrentBalance}
                  listLoading={listLoading}
                  progress={progress}
                  openUploadModal={openUploadModal}
                  onDeleteIem={onDeleteIem}
                  onDelWallet={onDelWallet}
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                  postAccountOverview={postAccountOverview}
                  usdcAddress={USTD_ADDRESS}
                  bnbAddress={BNB_ADDRESS}
                  tokenAInfo={tokenAInfo}
                  tokenBInfo={tokenBInfo}
                />
              </div>
            </div>
            <div className="swap-box-row stretch">
              <div className="swap-sider">
                <SwapParamsSetting form={form} tokenAInfo={tokenAInfo} otherTokenInfo={otherTokenInfo} queryOtherTokenInfo={queryOtherTokenInfo} isTokenANativeOrStable={isTokenANativeOrStable} isTokenBNativeOrStable={isTokenBNativeOrStable} />
              </div>
              <div className="swap-main">
                <Logs logs={logs} handleClearLogs={handleClearLogs} tokenAInfo={tokenAInfo} tokenBInfo={tokenBInfo} />
              </div>
            </div>
            <Form.Item className='form-item-align'>
              <Flex gap={20}>
                <Button type="primary" className='form-submit'
                  htmlType="submit" disabled={loading} onClick={onSubmit}
                >
                  {step === 0 && t("batchSwap.startSwap")}
                  {
                    step === 1
                    &&
                    loading
                    &&
                    <>
                      <Loader>
                        <img style={{ width: "16px" }} src={cdnUrl(`${imgPathPrefix}loading.webp`)} alt="" />
                      </Loader>
                      {/* {t("batchSwap.batchSwaping") + `${completedTasks}/${selectedRowKeys.length}`} */}
                      {t("batchSwap.batchSwaping")}
                    </>
                  }
                </Button>
                {
                  step === 1
                  &&
                  loading
                  &&

                  <Button className='form-stop' onClick={stopSwap}>
                    {
                      isStopping ?
                        <>
                          <Loader>
                            <img style={{ width: "16px" }} src={cdnUrl(`${imgPathPrefix}loading.webp`)} alt="" />
                          </Loader>
                          {t("batchSwap.stopping")}
                        </>
                        :
                        t("batchSwap.stopSwap")
                    }
                  </Button>
                }

              </Flex>
            </Form.Item>
            <div className='get-fee'>
              <span>{t("batchSwap.newSwapFeeTip", {
                rate: swapFeeRate,
              })}</span>
            </div>
          </div>
        </div>
      </Form>
      <Modal
        wrapClassName="sl-token-create-modal"
        title={null}
        open={isSuccessModal}
        // onOk={handleOk}
        onCancel={hideSuccessModal}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        footer={null}
        centered
      >
        <div className='sl-hash-modal-main sl-close-modal-main'>
          <div className='sl-hash-modal-title'><img src={cdnUrl(`/img/modal/success.webp`)} className='ico' /> <span>{t("batchSwap.batchSwapSuccess")}</span></div>
          <div className='sl-token-create-modal-content'>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '16px' }}>
              <p style={{ color: 'rgba(0, 0, 0, 0.80)' }}>{t("batchSwap.successCount")}</p>
              <p>{completedTasks}</p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '16px' }}>
              <p style={{ color: 'rgba(0, 0, 0, 0.80)' }}>{t("batchSwap.selectedCount")}</p>
              <p>{selectedRowKeys.length}</p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '16px' }}>
              <p style={{ color: 'rgba(0, 0, 0, 0.80)' }}>{t("batchSwap.allNativeBalance", { symbol: getSymbol() })}</p>
              <p>{`${accountOverview?.balance} ${getSymbol()}`}</p>
            </div>
            {!isSuiCoinType(tokenAInfo.coinType) &&
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '16px' }}>
                <p style={{ color: 'rgba(0, 0, 0, 0.80)' }}>{t("batchSwap.AllStableBalance", { stableSymbol: tokenAInfo.symbol })}</p>
                {/* <p>{`${accountOverview?.Balance} ${stableCoins[0].symbol}`}</p> */}
                <p>{`${accountOverview?.tokenABalance} ${tokenAInfo.symbol}`}</p>
              </div>}
            {!isSuiCoinType(tokenBInfo.coinType) && <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '16px' }}>
              <p style={{ color: 'rgba(0, 0, 0, 0.80)' }}>{t("batchSwap.AllStableBalance", { stableSymbol: tokenBInfo.symbol })}</p>
              {/* <p>{`${accountOverview?.Balance} ${stableCoins[0].symbol}`}</p> */}
              <p>{`${accountOverview?.tokenBBalance} ${tokenBInfo.symbol}`}</p>
            </div>}
          </div>
          <div className='sl-hash-modal-footer one-btn'>
            <Button onClick={hideSuccessModal}>{t("components.close")}</Button>
            {/* <a href={`${ETHERSCAN_URL}/token/${tokenAddrCus}`} target='_blank'>{t("tokenCreation.viewOnChain")}</a> */}
          </div>
        </div>

      </Modal>
      <UploadModal ref={uploadModalRef} onSuccess={onSubmitKeyPair} />
      {/* <button onClick={async () => {
        const getOtherTokenInfo = async () => {
          try {
            const routers = await ag.findRouters({
              from: tokenA,
              target: tokenB,
              amount: parseUnits("1", tokenAInfo.decimals),
              byAmountIn: true
            })
            console.log("routers", routers)
            console.log("routers?.amountIn.toString()", routers?.amountIn.toString());
            console.log("routers?.amountOut.toString()", routers?.amountOut.toString());

          } catch (error) {
            console.error("getOtherTokenInfo error:", error);
            return {
              price: 0,
              symbol: "",
            };
          }
        };
        await getOtherTokenInfo();
      }}> 哈哈哈</button>

      <button onClick={async () => {
        const tx = new Transaction();
        const privateKey = "suiprivkey1qzyymxk39evwq04yj030f9llxyxz3pwvd0tgmnudjwmm76j5kw9vwp87pp2";
        const { scheme, secretKey } = decodeSuiPrivateKey(privateKey);
        let keypair;
        switch (scheme) {
          case 'ED25519':
            keypair = Ed25519Keypair.fromSecretKey(secretKey);
            break;
          case 'Secp256k1':
            keypair = Secp256k1Keypair.fromSecretKey(secretKey);
            break;
          case 'Secp256r1':
            keypair = Secp256r1Keypair.fromSecretKey(secretKey);
            break;
          default:
            throw new Error(`Unsupported scheme: ${scheme}`);
        }
        const [coin1] = tx.splitCoins(tx.gas, [tx.pure.u64(parseUnits("0.1", 9))]);
        tx.transferObjects([coin1], tx.pure.address("0xb5889fb7b82f799b180d7f5dc78511cd92958052007cec63df04ffcc7e73ce46"));
        const res = await suiClient.signAndExecuteTransaction({
          signer: keypair,
          transaction: tx,
          options: { showEffects: true, showBalanceChanges: true },
        });
        console.log("res.digest", res.digest)
      }}>测试signer是否会自动合并gascoin</button> */}
    </>
  )
}
